module.exports = __webpack_public_path__ + "static/media/Longline_logo_web.759d29d0.svg";